import styled from 'styled-components';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Input = styled(materialUI.TextField)`
  display: flex;
  color: ${color.grey9};
  border-radius: 40px;
  min-width: 70px;
  width: 100%;
  background-color: ${(props) => props.style?.color};
`;
